<template>
    <div id="score-conversion" :class="theme">
        <img v-if="theme == 'day'" class="item-img item1" src="@/assets/introduce/item1.png" alt="">
        <img v-if="theme == 'day'"  class="item-img item2" src="@/assets/introduce/item2.png" alt="">
        <img v-if="theme == 'night'"  class="item-img item1" src="@/assets/introduce/item-b1.png" alt="">
        <img v-if="theme == 'night'"  class="item-img item2" src="@/assets/introduce/item-b2.png" alt="">
        <div class="content-box">
            <div class="part-one">
                <h1>一、兑换条件</h1>
                <p>1、积分兑换比例为1:1；</p>
                <div class="space"></div>
                <p>2、达到3000积分时即可通过“积分兑换”进行申请，通过审核后获取GZT。</p>
            </div>
            <div class="part-two">
                <h1>二、GZT价值</h1>
                <p>1、金果子官方将以项目产生的利润回购GZT，回购价格分别不低于0.04元，0.06元，0.08元。由于项目开发进展等原因，具体回购时间请等待金果子官方通知；</p>
                <div class="space"></div>
                <p>2、目前金果子认证的商家号正在场外回购GZT，有需要的用户可以添加商家号微信（JGZ_888)；</p>
                <div class="space"></div>
                <p>3、持有GZT可抵扣合约交易手续费；</p> 
                <div class="space"></div>
                <p>4、进入数据核心社群，获取独家数据报告；</p> 
                <div class="space"></div>
                <p>5、不定时兑换项目方糖果代币、实体周边产品；</p> 
                <div class="space"></div>
                <p>6、项目方、交易所、媒体等合作机构可兑换部分合作权益；</p> 
            </div>
            <div class="part-three">
                <h1>三、GZT介绍</h1>
                <p>GZT是由J.Golden Zone Services Pvt.Ltd基于ERC20协议发行的社区积分通证，GZT不会进行如IEO、ICO等任何形式的募资，目前仅能通过官方兑换通道将金果子积分兑换为GZT。未来，金果子将会围绕金果子积分和GZT，赋能更多生态玩法，请各位用户拭目以待！</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScoreConversion',
    data() {
        return {
            theme: 'day'
        }
    },
    
    mounted(){
        this.theme = this.$route.query.theme ? this.$route.query.theme : 'day';
    },

    methods: {

    }
}
</script>

<style lang='less'>
#score-conversion {
    // min-height: 1356px;
    min-height: 100vh;
	width: 100%;
    position: relative;
    background: #ffffff;
    font-family: PingFang SC;
    color: #33333A;
    &.night{
        color: #E3E3E1;
        background: #181820;
        .content-box .line {
            background: #2A2A36;
        }
        .content-box {
            background: #181820;
        }
    }
    .item-img {
        position: absolute;
        z-index: 0;
    }
    .item1 {
        top: 0;
        left: 0;
        width: 260px;
        height: 260px;
    }
    .item2{
        bottom: 0;
        right: 0;
        width: 360px;
        height: 360px;
    }
    .content-box {
        text-align: left;
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
        padding: 70px 40px 40px 40px;
        h1 {
            font-size: 34px;
            font-weight: bold;
            line-height: 48px;
            margin-bottom: 20px;
        }
        p {
            font-size: 30px;
            line-height: 45px;
        }
        .space {
            width: 100%;
            height: 20px;
        }
        .line {
            height: 1px;
            width: 100%;
            margin-bottom: 50px;
            background: #EBECF0;
        }
        .part-one {
            margin-bottom: 50px;
        }
        .part-two {
            margin-bottom: 50px;
        }
        .part-three {
        }
    }
}
</style>
